// extracted by mini-css-extract-plugin
module.exports = {"container":"BreadcrumbContainer_container__EDJcE"};